<template>
  <div id="app" :style='"right:"+appRight+""'>
    <div class="pc-nav">
      <ul v-show='showcomPc' class="app-ul">
        <span class="logo" style="left:-10px"></span><span class="logoTangmama"></span>
        <span class="lis">
          <li style="margin-left:450px" :class="{ 'onThis1':onThisS===1 }" @click="onThis(1)"><router-link tag="nav" to="/">首页</router-link></li>
          <li :class="{ 'onThis1':onThisS===2 }" @click="onThis(2)">客户端</li>
          <li :class="{ 'onThis1':onThisS===7 }" @click="onThis(7)"><router-link tag="nav" to="/userInfo">糖糖圈会员</router-link></li>

          <li :class="{ 'onThis1':onThisS===3 }" @click="onThis(3)"><router-link tag="nav" to="/ClinicAppointment">诊所预约</router-link></li>
          <li :class="{ 'onThis1':onThisS===4 }" @click="onThis(4)"><router-link tag="nav" to="/content">控糖百科</router-link></li>
          <li :class="{ 'onThis1':onThisS===5 }" @click="onThis(5)"><router-link tag="nav" to="/sugarControl">数据上传</router-link></li>
          <li :class="{ 'onThis1':onThisS===6 }" @click="onThis(6)"><router-link tag="nav" to="/aboutUs">关于我们</router-link></li>

          
          <a style="margin-right:0" title="医护登录" target="_blank" :href='""+host+"/login.html"' class="DL">医护登录</a>
          <a style="margin-right:25px" title="同伴社区" target="_blank" href='https://www.ttq.so/share' class="DL">同伴社区</a>
          <!-- <a title="同伴社区" target="_blank" href='https://api.ttq.so/html/ttqTopic/#/' class="DL">同伴社区</a>
         -->
        
        </span>
      </ul>
    </div>
    <section v-show="showcomHs" class="hs-nav">
      <i class="hs-logo1"></i>
      <span class="hs-menu" @click="menu">
        <i class="menu-i"></i><i style="margin: 10px 0" class="menu-i"></i><i class="menu-i"></i>
      </span>
    </section>
    <!--滑动模块-->
    <section v-show="slideShow" @click="close" class="slide-box" @touchmove.prevent></section>
    <transition name="fade">
      <section class="slides" :style='"right:"+slideRight+""'  @touchmove.prevent>
        <div class="slideTitle">
          <i class="logo3"></i>
          <label @click="close" class="close">×</label>
        </div>
        <ul class="slideUl">
          <router-link to="/Hello"><li @click="routerLink">首页</li></router-link>
          <a href="http://a.app.qq.com/o/simple.jsp?pkgname=so.ttq"><li>糖糖圈客户端</li></a>
          <router-link to="/article"><li @click="routerLink">控糖百科</li></router-link>
          <router-link to="/aboutUsHs"> <li @click="routerLink">关于我们</li></router-link>
        </ul>
      </section>
    </transition>
    <router-view @getMsgFormSon="getMsgFormSon()"></router-view>

    <client ref="client"></client>

  </div>
</template>

<script>
import client from './page/client.vue'
let is=1;
export default {
  name: 'app',
  components: {
     client
  },
  data () {//定义存放数据函数
    return {
      host: this.GLOBAL.host,
      num: 123456,
      showcomPc:true,
      showcomHs:true,
      onThisS:1,
      slideShow:false,
      slideRight:'-50%',
      appRight:'0'
    }
  },
  methods: {
    getMsgFormSon(){
      console.log(111)
      this.onThisS=7;
    },
    
    //定义方法函数
    onThis (i){

      
      console.log(i)
      if(i==2){
        //window.scrollTo(0,3000);
        this.$refs.client.show=true
        //this.onThisS=2;
      }
      else{
        window.scrollTo(0,0);
        this.onThisS=i;
      }
    },
    close (){
      this.slideShow=false;
      this.slideRight='-50%'
      this.appRight='0'
    },
    menu (){
      this.slideShow=true;
      this.slideRight='0'
      this.appRight='50%'
    },
    routerLink (){
      this.slideShow=false;
      this.slideRight='-50%'
      this.appRight='0'
    }
},
  created () {
  //定义页面加载前执行函数
    document.title = '爱宝惟官网'
    let sUserAgent=navigator.userAgent;
    let mobileAgents=['Android','iPhone','Symbian','WindowsPhone','iPod','BlackBerry','Windows CE'];
    let goUrl = 0;
    for( let i in mobileAgents ){
      if(sUserAgent.indexOf(mobileAgents[i]) > -1){
        goUrl = 1;
        break;
      }
    }
    if (goUrl == 1){
      this.$router.push('/Hello')
      this.showcomPc=false
    }else{
      this.$router.push('/')
      this.showcomHs=false;
    }

  }
}
</script>

<style>
  * {margin: 0;padding: 0;list-style: none;font-family: "Microsoft Yahei";-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-touch-callout:none;border: none;}
  body,html{width: 100%;height: 100%;}
  a{text-decoration: none;color: #000}
  nav{cursor:pointer;}
  span{display: block}
  i,label{display: inline-block}
  .pc-nav{position: fixed;top:0;left: 0;z-index: 99;background: #fff;width: 100%;box-shadow: 0 0 5px #888;}
  #app{position: relative;right: 0;transition: all .2s linear;}
  .hs-nav{padding: 20px 0;position: fixed;top: 0;left: 0;z-index: 9;width: 100%;background: #fff;box-shadow: 0 0 5px #888;}
  .hs-logo1{background: url("../site/logo.png") no-repeat;width: 176px;height: 72px;background-size: cover;margin-left: 30px}
  .hs-menu{position: absolute;right: 30px; top:40px;}
  .menu-i{background: #00b9cd;width: 50px;height: 3px;border-radius: 10px;display: block}
  .onThis1{color: #02c3d8 !important;border-bottom: #02c3d8 2px solid;height: 60px}
  .app-ul{min-width: 1400px;height: 90px;list-style: none;margin: 0 auto;position: relative;max-width: 1200px;}
  .lis{line-height: 90px;color: #333 !important;}
  .lis li{float: left;}
  .lis a{float:right; margin-top:30px; display: inline-block;width: 100px; height: 30px; text-align: center !important; color:#00b9cd; line-height: 30px; border: 1px solid #02BFD3;border-radius: 20px;background-color: #F2FEFF;}
  .app-ul li{margin-left: 40px;float: left;font-family: "MicroSoft Yahei";color: #333;font-size: 16px;font-weight: bold;}
  .logo{background-size: 100% 100%;width: 157px;height: 64px;position: absolute;left: 0;background-image: url("../site/logo.png");top:13px}
  .box61{text-align: left}
  .boxEnd-1{width: 39%;display: inline-block;text-align: left}
  .boxEnd-1 p{line-height: 30px;color: #333}
  .boxEnd-2 span{position: relative;top: -30px}
  .boxEnd-2{width: 60%;display: inline-block;border-left: 1px solid #999;color: #00b9cd;vertical-align: bottom;text-align: left}
  
  .logoTangmama{background-size: 100% 100%;width: 187px;height: 72px;position: absolute;left:210px;background-image: url("../site/logoTmm.png");top:13px}
  
  .ewm1{display:inline-block;background: url("../site/wb-ewm.png"); background-size:100%;width: 120px;height: 120px;margin-left: 30px;text-align: center}
  .ewm2{display:inline-block;background: url("../site/wx-ewm.png");background-size:100%;width: 120px;height: 120px;margin-left: 30px;text-align: center}
  .yptu{display:inline-block;background: url("../site/yp.png");background-size:100%;width: 240px;height: 135px;text-align: center;color: #313030;font-size: 15px}
  .xian{border-left: 1px solid #999;height: 169px;width: 1px;display: inline-block;vertical-align: bottom;margin: 0 30px}
  .wxb,.ypwz{position: relative;top:135px}
  .mac{background: url("../site/mac.png");width: 117px;height: 46px;display: inline-block;position: relative;top:140px}
  .win{background: url("../site/win.png");width: 117px;height: 46px;display: inline-block;position: relative;top:140px}
  .box-ends{max-width: 1200px;min-width:800px;margin: 0 auto;padding: 20px 0;color: #333;font-size: 16px}
  .box-ends label{margin: 0 125px 0 100px}
  .slide-box{position: fixed;top:0;left:0;width: 100%;height: 100%;background: #000;z-index: 99;opacity: 0.5}
  .slides{position: fixed;width:50%;background: #fff;height: 100%;top: 0;right:-50%;z-index: 99;transition: all .2s linear;}
  .slideTitle{background: #08c0d4;height: 116px;width:100%;position: relative}
  .slideTitle>*{vertical-align: middle;line-height: 100px}
  .logo3{background: url("../site/logo3.png") no-repeat center;height: 100%;width: 134px;position:absolute;left: 10%}
  .close{color: #fff;font-size: 60px;position:absolute;right: 10%;}
  .slideUl li{color: #333;font-size: 28px;border-bottom: 1px solid #dadada;padding: 20px 0;text-indent: 1.5em;background: url("../site/kf.png") no-repeat 85% center}
  .DL{display: inline-block;}
  .DL:hover{color: #00b9cd}
  li:hover{color:#25B8C8;}
</style>



// WEBPACK FOOTER //
// App.vue?08ff95c5